<script lang="ts" setup>
import type { TruckDto } from "@/api/trucks/dto/truck.dto";
import { computed } from "vue";
import { TruckTypeList } from "@/constants/truck";
import TruckMember from "@/components/truck/TruckMember.vue";
import TruckLocationInfo from "@/components/truck/TruckLocationInfo.vue";
import { useI18n } from "vue-i18n";
import TruckStatus from "@/components/statuses/TruckStatus.vue";

const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    truck: TruckDto;
    hideStatus?: boolean;
  }>(),
  {
    hideStatus: false,
  },
);

const truckTypeName = computed(() => {
  return TruckTypeList.find((item) => item.id == props.truck.type)?.name;
});
</script>

<template>
  <div class="bg-grey-lighten-4 pa-4">
    <v-row>
      <v-col cols="6">
        <div class="d-flex align-center">
          <router-link
            v-if="props.truck.id"
            :to="{ name: 'truck-view', params: { id: props.truck.id } }"
            class="text-primary text-decoration-none font-weight-500"
            data-qa="truck-number"
            target="_blank"
          >
            Truck {{ truck.number }}
          </router-link>

          <truck-status v-if="!hideStatus" :truck="props.truck" class="ml-2" data-qa="truck-status" />
        </div>

        <div v-if="truckTypeName" class="font-size-12 text-grey-darken-1 mt-2 font-weight-500" data-qa="truck-type">
          {{ truckTypeName }}
        </div>

        <truck-member
          v-if="truck.driverId && truck.driver"
          :member="truck.driver"
          class="mt-3 d-flex align-center"
          hide-status
          language-light
        />

        <truck-member
          v-if="truck.ownerId && truck.driverId !== truck.ownerId"
          :member="truck.owner"
          class="mt-3 d-flex align-center"
          hide-status
          language-light
        />
      </v-col>
      <v-col cols="6">
        <div class="font-size-12 font-weight-500 text-grey-darken-1">{{ t("trucks.current-location") }}</div>
        <truck-location-info
          v-if="truck.currentLocation?.coordinates"
          :location="truck.currentLocation"
          :time="truck.currentLocationTime"
          show-indicator
        />
      </v-col>
    </v-row>

    <slot></slot>
  </div>
</template>
